import moment from 'moment'

import { hostname } from '@/utils/hostname'

export const sharedMethods = {
  getAudio(audio) {
    return `https://${hostname()}/backend/asterisk/gravacao/player/${audio}`
  },
  getAudioConference(audio) {
    return `https://${hostname()}/backend/asterisk/relatorios/download/conferencia/${audio}`
  },
  convertDateFormat(date) {
    return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
  },
  getAnyTimeCall(status, dateStartCall, dateEndCall) {
    if (status !== 'atendida') {
      return '00:00:00'
    }

    const calculatedTime = moment(dateEndCall, 'YYYY-MM-DD HH:mm:ss').diff(moment(dateStartCall, 'YYYY-MM-DD HH:mm:ss'))
    const duration = moment.duration(calculatedTime)
    return Math.floor(duration.asHours()) + moment.utc(calculatedTime).format('H:mm:ss')
  },
  obtemAcao(acao) {
    return acao.split('\\')[acao.split('\\').length - 1]
  },
  obtemConferencia(idConferencia) {
    if (!idConferencia || typeof idConferencia === 'undefined') {
      return 'Pendente'
    }
    const conferencia = this.getConferencias.find(conferencia => conferencia._id === idConferencia)
    return conferencia.description
  },
  
  obtemAtendente(atendente, numeroOrigem, numeroDestino) {
    if (typeof atendente === 'undefined') {
      return 'Não atendida'
    }

    if (typeof atendente.split('-')[2] !== 'undefined') {
      return `${atendente.split('-')[0]} - ${atendente.split('-')[1]}`
    }

    if (atendente.includes('Local')) {
      return atendente.split('@')[0].split('/')[1]
    }

    if (typeof atendente.split('-')[1] === 'undefined') {
      return atendente
    }

    const verificacao = atendente.split('-')[0].includes('.')
    if (!verificacao) {
      return atendente.split('-')[0].split('/')[1]
    }
    if (numeroOrigem.length >= 8) {
      return numeroOrigem
    }

    return numeroDestino
  },
}
